// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3vUpN","content":"GlobalSearch_content__1wF39"};